// Local translations
export const T = {
  en_GB: {
    delete: "Delete",
    saveProductFirst: "Save the product first to manage documents.",
    noDocumentTypesConfigured: "No document types configured for this collection.",
    failedToLoadDocuments: "Failed to load documents",
    goToDocumentsTab:
      'Go to the "Documents" tab in collection settings to configure document types.',
    attachDocumentsDesc:
      "Attach documents to this product per language. Use the search button to find documents in Morningstar, or upload a PDF manually.",
    searchFailed: "Search failed",
    noMatchingDocument: "No matching document found in Morningstar",
    documentFoundAndLinked: "Document found and linked",
    documentRefreshed: "Document refreshed",
    refresh: "Refresh from Morningstar",
    failedToSaveDocument: "Failed to save document",
    failedToRemoveDocument: "Failed to remove document",
    documentRemoved: "Document removed",
    onlyPdfAllowed: "Only PDF files are allowed",
    fileSizeExceeds: "File size exceeds 10MB limit",
    uploadFailed: "Upload failed",
    documentUploaded: "Document uploaded successfully",
    uploadFailedRetry: "Upload failed. Please try again.",
    morningstar: "Morningstar",
    uploaded: "Uploaded",
    documentDate: "Document Date",
    na: "N/A",
    lastSynced: "Last synced",
    uploadedFile: "Uploaded file",
    open: "Open",
    searching: "Searching...",
    searchMorningstar: "Search Morningstar",
    addIsinToSearch: "Add ISIN to product to search Morningstar",
    noMsMappingConfigured: "No Morningstar mapping configured",
    uploading: "Uploading...",
    uploadPdf: "Upload PDF",
    language: "Language",
  },
  nb_NO: {
    delete: "Slett",
    saveProductFirst: "Lagre produktet først for å administrere dokumenter.",
    noDocumentTypesConfigured: "Ingen dokumenttyper konfigurert for denne samlingen.",
    failedToLoadDocuments: "Kunne ikke laste dokumenter",
    goToDocumentsTab:
      'Gå til "Dokumenter"-fanen i samlingsinnstillingene for å konfigurere dokumenttyper.',
    attachDocumentsDesc:
      "Legg ved dokumenter til dette produktet per språk. Bruk søkeknappen for å finne dokumenter i Morningstar, eller last opp en PDF manuelt.",
    searchFailed: "Søk mislyktes",
    noMatchingDocument: "Ingen matchende dokument funnet i Morningstar",
    documentFoundAndLinked: "Dokument funnet og koblet",
    documentRefreshed: "Dokument oppdatert",
    refresh: "Oppdater fra Morningstar",
    failedToSaveDocument: "Kunne ikke lagre dokument",
    failedToRemoveDocument: "Kunne ikke fjerne dokument",
    documentRemoved: "Dokument fjernet",
    onlyPdfAllowed: "Kun PDF-filer er tillatt",
    fileSizeExceeds: "Filstørrelsen overstiger 10MB-grensen",
    uploadFailed: "Opplasting mislyktes",
    documentUploaded: "Dokument lastet opp",
    uploadFailedRetry: "Opplasting mislyktes. Vennligst prøv igjen.",
    morningstar: "Morningstar",
    uploaded: "Opplastet",
    documentDate: "Dokumentdato",
    na: "I/A",
    lastSynced: "Sist synkronisert",
    uploadedFile: "Opplastet fil",
    open: "Åpne",
    searching: "Søker...",
    searchMorningstar: "Søk i Morningstar",
    addIsinToSearch: "Legg til ISIN på produktet for å søke i Morningstar",
    noMsMappingConfigured: "Ingen Morningstar-kobling konfigurert",
    uploading: "Laster opp...",
    uploadPdf: "Last opp PDF",
    language: "Språk",
  },
} as const;
